/**
 * Calculator - Base class for substrate calculations
 *
 * @abstract
 * @class Calculator
 */
class Calculator {
    /**
     * @param {Object} dimensions - Object containing dimension values
     */
    constructor(dimensions = {}) {
        if (new.target === Calculator) {
            throw new TypeError('Calculator is an abstract class and cannot be instantiated directly');
        }
        this.dimensions = { ...dimensions };
        this.substrateVolume = 0;
        this.drainageVolume = 0;
    }

    /**
     * Calculate substrate volume
     *
     * @abstract
     * @returns {number} Volume in liters
     */
    calculateSubstrateVolume() {
        throw new Error('calculateSubstrateVolume() must be implemented by subclass');
    }

    /**
     * Calculate drainage volume
     *
     * @abstract
     * @returns {number} Volume in liters
     */
    calculateDrainageVolume() {
        throw new Error('calculateDrainageVolume() must be implemented by subclass');
    }

    /**
     * Calculate all volumes
     *
     * @returns {Object} Object containing substrateVolume and drainageVolume
     */
    calculate() {
        this.substrateVolume = this.calculateSubstrateVolume();
        this.drainageVolume = this.calculateDrainageVolume();
        return {
            substrateVolume: this.substrateVolume,
            drainageVolume: this.drainageVolume
        };
    }

    /**
     * Get results formatted to 2 decimal places
     *
     * @returns {Object} Formatted results
     */
    getFormattedResults() {
        return {
            substrateVolume: Math.round(this.substrateVolume * 100) / 100,
            drainageVolume: Math.round(this.drainageVolume * 100) / 100
        };
    }
}

export default Calculator;
